import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { SettingsRootParamList } from "../../../../types";
import { useLinklyPosContext } from "../../../../utilities/linkly";
import { LinklyConfiguration } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { useLazyQuery } from "@apollo/client";
import {
  Card,
  FlatActionList,
  Page,
  Stack,
  TextButton,
} from "@towersystems/roam-common-native";
import { useFocusEffect } from "@react-navigation/native";
import { QUERY_LINKLY_CONFIGURATION } from "../../common/constants";

export type LinklySettingsLandingScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "LinklySettingsLandingScreen"
>;

export const LinklySettingsLandingScreen = ({
  route,
  navigation,
}: LinklySettingsLandingScreenProps) => {
  const [config, setConfig] = React.useState<undefined | LinklyConfiguration>(
    undefined
  );

  const [query] = useLazyQuery<{
    linklyConfiguration: LinklyConfiguration;
  }>(QUERY_LINKLY_CONFIGURATION);

  const linklyContext = useLinklyPosContext();

  useFocusEffect(
    React.useCallback(() => {
      query({
        variables: {
          paymentMethodId: route.params.paymentMethodId,
        },
      }).then((result) => {
        if (result.data) {
          setConfig(result.data.linklyConfiguration);
        }
      });
    }, [route.params.paymentMethodId])
  );

  const { pairSecret } = linklyContext.state;

  const pairNewMarkup = config && (
    <Card>
      <FlatActionList
        items={[
          {
            key: "pair",
            title: "Pair New Pinpad",
            onPress: () => {
              navigation.navigate("LinklyPairPinpadScreen", {
                configurationId: config.id,
                paymentMethodId: route.params.paymentMethodId,
              });
            },
          },
          {
            key: "receipt_print",
            title: "Receipt Auto Print",
            onPress: () =>
              navigation.navigate("LinklySettingsEditAutoPrintScreen", {
                paymentMethodId: route.params.paymentMethodId,
                selectedValue: config.receiptAutoPrint,
              }),
            componentRight: () => {
              return (
                <TextButton
                  onPress={() =>
                    navigation.navigate("LinklySettingsEditAutoPrintScreen", {
                      paymentMethodId: route.params.paymentMethodId,
                      selectedValue: config.receiptAutoPrint,
                    })
                  }
                >
                  {config.receiptAutoPrint}
                </TextButton>
              );
            },
          },
        ]}
      />
    </Card>
  );

  const pairedMarkup = config && config.pairedPinpads.length >= 1 && (
    <Card title="Paired Pinpads">
      <FlatActionList
        items={
          config.pairedPinpads.map((pinpad) => ({
            key: pinpad.id,
            title: pinpad.name,
            subTitle: pinpad.secret === pairSecret ? "Active" : undefined,
            onPress: () => {
              navigation.navigate("LinklyPinpadSettingsListScreen", {
                pinpadId: pinpad.id,
                isActive: pinpad.secret === pairSecret,
                pinpadSecret: pinpad.secret,
              });
            },
          })) || []
        }
      />
    </Card>
  );

  return (
    <Page title="Configure Linkly">
      <Stack vertical>
        {pairNewMarkup}
        {pairedMarkup}
      </Stack>
    </Page>
  );
};
